/** Normalize org program row from GET/PUT /v2/admin/organizations/{orgId}/programs. */
import { normalizeEligibilityRaw } from './careProgramEligibility';

export function normalizeOrgCareProgramRow(raw) {
  const p = raw?.program ?? raw ?? {};
  const orgSettings = raw?.org_settings ?? raw?.settings ?? {};
  return {
    program_id: p.program_id ?? raw?.program_id ?? raw?.id,
    program_code: p.program_code ?? raw?.program_code,
    display_name: p.display_name ?? raw?.display_name,
    description: p.description ?? raw?.description,
    status: p.status ?? raw?.status ?? 'draft',
    checkin_type_id: p.checkin_type_id ?? raw?.checkin_type_id,
    active_from: p.active_from ?? raw?.active_from ?? null,
    active_to: p.active_to ?? raw?.active_to ?? null,
    enabled: Boolean(raw?.enabled),
    enabled_from: raw?.enabled_from ?? null,
    enabled_to: raw?.enabled_to ?? null,
    org_subscription_active: Boolean(raw?.org_subscription_active),
    org_subscription_for_audit: Boolean(raw?.org_subscription_for_audit),
    program_published: raw?.program_published ?? (p.status === 'published'),
    program_in_active_window: Boolean(raw?.program_in_active_window),
    portal_visible: Boolean(raw?.portal_visible),
    audit_visible: Boolean(raw?.audit_visible),
    has_program_activity: Boolean(raw?.has_program_activity),
    settings: typeof orgSettings === 'object' && orgSettings ? orgSettings : {},
  };
}

/** Normalize care program list row for table display. */
export function normalizeCareProgramListRow(raw) {
  const p = raw?.program ?? raw ?? {};
  return {
    program_id: p.program_id ?? raw?.program_id ?? raw?.id,
    program_code: p.program_code ?? raw?.program_code,
    display_name: p.display_name ?? raw?.display_name,
    description: p.description ?? raw?.description,
    status: p.status ?? raw?.status ?? 'draft',
    checkin_type_id: p.checkin_type_id ?? raw?.checkin_type_id,
    plans_categories_id: p.plans_categories_id ?? raw?.plans_categories_id,
    version: p.version ?? raw?.version,
    active_from: p.active_from ?? raw?.active_from,
    active_to: p.active_to ?? raw?.active_to,
    member_scope: p.config?.eligibility?.member_scope ?? raw?.config?.eligibility?.member_scope,
  };
}

export const PROGRAM_STATUS_COLORS = {
  draft: 'default',
  published: 'green',
  archived: 'orange',
};

export const GATE_PERIOD_OPTIONS = [
  { value: 'lifetime', label: 'Lifetime — once ever' },
  { value: 'annual', label: 'Annual — once per calendar year' },
  { value: 'org_window', label: 'Org window — once per org subscription period' },
];

export const COMPLETION_WHEN_OPTIONS = [
  { value: 'any_of', label: 'Any rule matches (OR)' },
  { value: 'all_of', label: 'All rules must match (AND)' },
];

/** Deep-merge schema defaults with saved config. */
export function mergeProgramConfig(defaults = {}, existing = {}) {
  const base = typeof defaults === 'object' && defaults ? { ...defaults } : {};
  const cur = typeof existing === 'object' && existing ? existing : {};
  return {
    ...base,
    ...cur,
    eligibility: normalizeEligibilityRaw({
      ...(base.eligibility || {}),
      ...(cur.eligibility || {}),
      genders: cur.eligibility?.genders ?? base.eligibility?.genders ?? [],
    }),
    utilization: {
      ...(base.utilization || {}),
      ...(cur.utilization || {}),
      completion: {
        ...(base.utilization?.completion || {}),
        ...(cur.utilization?.completion || {}),
        rules: cur.utilization?.completion?.rules ?? base.utilization?.completion?.rules ?? [],
      },
      status_labels: {
        ...(base.utilization?.status_labels || {}),
        ...(cur.utilization?.status_labels || {}),
      },
    },
    gates: { ...(base.gates || {}), ...(cur.gates || {}) },
    reporting: {
      ...(base.reporting || {}),
      ...(cur.reporting || {}),
      columns: cur.reporting?.columns ?? base.reporting?.columns ?? [],
    },
    ui: {
      ...(base.ui || {}),
      ...(cur.ui || {}),
      hr: { ...(base.ui?.hr || {}), ...(cur.ui?.hr || {}) },
      facility: { ...(base.ui?.facility || {}), ...(cur.ui?.facility || {}) },
    },
  };
}

export const emptyReportColumn = () => ({
  key: `col-${Date.now()}`,
  label: '',
  source: '',
});

export const emptyCompletionRule = () => ({
  type: 'checkin_exists',
  value: null,
});
